export enum QuotaUpgrade {
  ZBA_BASIC = 1,
  ZBA_PRO = 10,
}
